import { yupResolver } from '@hookform/resolvers/yup';
import { Logger } from '@precert/logger';
import axios from 'axios';
import get from 'lodash/get';
import queryString from 'query-string';
import React, { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import urlJoin from 'url-join';

import { useConfig } from '../../../_components/config';

import Form from './form';
import schema from './schema';

const log = Logger('perc:request');

export function RequestForm() {
  const [submittedStatus, setSubmittedStatus] = useState(null);
  const [requestStatus, setRequestStatus] = useState({
    loading: false,
    error: null,
  });
  const { api, features } = useConfig();
  const navigate = useNavigate();
  const location = useLocation();
  const search = get(location, 'search', '');
  const query = queryString.parse(search);
  const defaultEmail = get(query, 'email', null);

  const submitForm = async ({ email }) => {
    log.debug('Submitting email request for form id', { email });
    setRequestStatus({ loading: true, error: null });
    try {
      const result = await axios({
        url: urlJoin(api, 'request'),
        method: 'post',
        data: {
          email,
          // track the user's browser time & time zone, for auditing/troubleshooting
          browserTime: new Date(),
          browserTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        withCredentials: true,
      });
      const emailSent = get(result, 'data');
      setSubmittedStatus(emailSent ? 'sent' : 'unneeded');
      setRequestStatus({ loading: false, error: null });
    } catch (error) {
      setRequestStatus({ loading: false, error: error });
      log.error('Error', error);
    }
  };

  const form = useForm({
    mode: 'all',
    resolver: yupResolver(schema(features)),
    defaultValues: { email: defaultEmail },
  });
  const { handleSubmit, reset } = form;
  return (
    <FormProvider {...form}>
      <Form
        loading={requestStatus.loading}
        error={requestStatus.error}
        submittedStatus={submittedStatus}
        onStart={() => navigate('/form/new-request')}
        onStartOver={() => {
          reset();
          setSubmittedStatus(null);
        }}
        handleSubmit={handleSubmit(async (...args) => {
          submitForm(...args);
        })}
      />
    </FormProvider>
  );
}
